import { useContext } from 'react';

import { GlobalTopicContext } from 'core/components/GlobalTopicProvider';


export default function withGlobalTopicContext(Component) {
  return function GlobalTopicComponent(props) {
    const topic = useContext(GlobalTopicContext);

    return <Component content={topic} {...props} />;
  };
}
